import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { patchBoardQueueGroup } from '../requests';

export const usePatchBoardQueueGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchBoardQueueGroup,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardQueueGroups],
      });
    },
  });
};
